export enum AddressUsage {
  END_CUST = 'END_CUST',
  SOLD_TO = 'SOLD_TO',
  BILL_TO = 'BILL_TO',
  SHIP_TO = 'SHIP_TO',
  MAIN_CONTACT = 'BUYER',
  IT_CONTACT = 'IT_CONTACT',
  INVOICE_RECIPIENT = 'INVOICE_RECIPIENT',
}

export enum AddressParams {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  COMPANY_NAME = 'companyName',
  INDUSTRY = 'industry',
  FORMAT_ADDRESS = 'formattedAddress',
  COUNTRY = 'country',
}

export enum DetailType {
  ADDRESS = 'ADDRESS',
  CONTACT = 'CONTACT',
}

export interface CheckoutReviewOrderComponentTexts {
  poNumberTooltip?: string;
  errorMessages: {tooLong: string};
  infoBox: {
    [AddressUsage.END_CUST]?: string;
    [AddressUsage.SOLD_TO]: string;
    [AddressUsage.BILL_TO]: string;
    [AddressUsage.SHIP_TO]: string;
    [AddressUsage.MAIN_CONTACT]: string;
    [AddressUsage.IT_CONTACT]: string;
  };
}

export interface OrderEntryConfiguration {
  account: string;
  currency: string;
  contract?: string;
  startDate: string;
  duration: {
    default: boolean;
    order: string;
    value: string;
    metric: {
      id: string;
      name: string;
      description: string;
    };
  };
  endDate: string;
  'EU-Access': string;
  itemId?: string;
  itemNumber?: string;
  product: string;
  pricingDate: string;
  renewalTypes: string;
  transactionType: string;
  vendorId: string;
  spendAmount?: number;
}
